import { useEffect, useState } from "react";
import ComingSoon from "./ComingSoon";
import FullSite from "./FullSite";
import AdminPanel from "./AdminPanel";
import CoffeeCheckoutPage from "./CoffeeCheckoutPage";
import CoffeeCheckoutConfirmPage from "./CoffeeCheckoutConfirmPage";
import WebshopPage from "./WebshopPage";
import CartCheckoutPage from "./CartCheckoutPage";
import { fetchSiteMode } from "./api";

function isAdminPath() {
  const path = window.location.pathname.replace(/\/+$/, "") || "/";
  return path === "/blpkmz";
}

function isCheckoutConfirmPath() {
  const path = window.location.pathname.replace(/\/+$/, "") || "/";
  return path === "/checkout/confirm";
}

function isCheckoutPath() {
  const path = window.location.pathname.replace(/\/+$/, "") || "/";
  return path === "/checkout";
}

function getShopRoute() {
  const path = window.location.pathname.replace(/\/+$/, "") || "/";
  if (path === "/webshop") return "shop";
  if (path === "/webshop/checkout") return "checkout";
  return "";
}

function App() {
  const [showAdmin, setShowAdmin] = useState(isAdminPath);
  const [showCheckoutConfirm, setShowCheckoutConfirm] = useState(isCheckoutConfirmPath);
  const [showCheckout, setShowCheckout] = useState(isCheckoutPath);
  const [shopRoute, setShopRoute] = useState(getShopRoute);
  // Live site is the default; coming-soon only if the API explicitly enables it.
  const [showComingSoon, setShowComingSoon] = useState(false);

  useEffect(() => {
    function syncRoute() {
      setShowAdmin(isAdminPath());
      setShowCheckoutConfirm(isCheckoutConfirmPath());
      setShowCheckout(isCheckoutPath());
      setShopRoute(getShopRoute());
    }
    syncRoute();
    window.addEventListener("popstate", syncRoute);
    return () => window.removeEventListener("popstate", syncRoute);
  }, []);

  useEffect(() => {
    if (showAdmin) return undefined;

    let cancelled = false;

    async function loadSiteMode() {
      try {
        const data = await fetchSiteMode();
        if (cancelled) return;
        setShowComingSoon(data.showComingSoon === true);
      } catch {
        if (!cancelled) setShowComingSoon(false);
      }
    }

    loadSiteMode();
    return () => {
      cancelled = true;
    };
  }, [showAdmin]);

  if (showAdmin) {
    return <AdminPanel />;
  }

  if (showCheckoutConfirm) {
    return <CoffeeCheckoutConfirmPage />;
  }

  if (showCheckout) {
    return <CoffeeCheckoutPage />;
  }

  if (shopRoute === "shop") {
    return <WebshopPage />;
  }

  if (shopRoute === "checkout") {
    return <CartCheckoutPage />;
  }

  return showComingSoon ? <ComingSoon /> : <FullSite />;
}

export default App;
